/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail`)
};

const es_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No aprobado`)
};

const de_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht bestanden`)
};

const nl_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet geslaagd`)
};

const fr_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échoué`)
};

const it_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non superato`)
};

const pt_br2_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprovado`)
};

const pt_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprovado`)
};

const ja_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不合格`)
};

const zh_cc_fail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未通过`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_fail = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_fail(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_fail", locale)
	if (locale === "en") return en_cc_fail(inputs)
	if (locale === "es") return es_cc_fail(inputs)
	if (locale === "de") return de_cc_fail(inputs)
	if (locale === "nl") return nl_cc_fail(inputs)
	if (locale === "fr") return fr_cc_fail(inputs)
	if (locale === "it") return it_cc_fail(inputs)
	if (locale === "pt-BR") return pt_br2_cc_fail(inputs)
	if (locale === "pt") return pt_cc_fail(inputs)
	if (locale === "ja") return ja_cc_fail(inputs)
	return zh_cc_fail(inputs)
};